import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const KaokuKbn = props => {
  return <Dropdown.Static kubunKey='kaoku_kbn' {...props} />
}
